/* ========== SIZE LABEL ========== */
function updateSizeLabel(input) {
  const label = document.querySelector(`label[for="${input.id}"]`);

  const sizeWrapper = input.closest('.size_option_input');
  if (!sizeWrapper) return;

  const sizeValueElement = sizeWrapper.querySelector('.size-value');

  const labelText = label.textContent.trim();
  const isAvailable = input.dataset.available !== 'false';

  sizeValueElement.textContent = isAvailable
    ? labelText
    : `${labelText} · ${outOfStockGlobalVariable}`;
}

/* ========== SWIPER ========== */
function initProductSwiper(rootEl) {
  const scope = rootEl || document;

  let container = scope.querySelector('.product__media.swiper');
  if (
    !container &&
    scope instanceof Element &&
    scope.matches('.product__media.swiper')
  ) {
    container = scope;
  }
  if (!container) return;

  if (container.swiper) {
    container.swiper.destroy(true, true);
  }

  new Swiper(container, {
    slidesPerView: 'auto',
    breakpoints: {
      1024: {
        enabled: false
      }
    },
    on: {
      slideChange() {
        if (window.innerWidth >= 1024) return;
        window.pushGallerySwipeOnce();
      }
    }
  });
}

/* ========== VARIANT MEDIA LOGIC ========== */

//Cart preparing: mediaId -> variantId -> featured_media
function buildMediaVariantMap(productJson) {
  const map = {};
  if (!productJson || !Array.isArray(productJson.variants)) return map;

  productJson.variants.forEach(variant => {
    const variantId = Number(variant.id);
    const feturedMedia = variant.featured_media;
    if (feturedMedia && feturedMedia.id != null) {
      map[Number(feturedMedia.id)] = variantId;
    }
  });

  return map;
}

// Finding id
function findVariantById(productJson, variantId) {
  const idNum = Number(variantId);
  return (
    productJson.variants.find(varinat => Number(varinat.id) === idNum) || null
  );
}

// Main Function: return array media
// from featured_media current/selectes to varinat featured_media next product variant.

function getMediaSliceForVariant(productJson, variantId) {
  if (!productJson || !Array.isArray(productJson.media)) return [];

  const mediaVariantMap = buildMediaVariantMap(productJson);
  const variant = findVariantById(productJson, variantId);

  if (!variant || !variant.featured_media) {
    return productJson.media;
  }

  const currentMediaId = Number(variant.featured_media.id);

  let started = false;
  const result = [];

  for (const media of productJson.media) {
    const mediaId = Number(media.id);
    const ownerVariantId = mediaVariantMap[mediaId] || null;

    if (!started) {
      if (mediaId === currentMediaId) {
        started = true;
        result.push(media);
      }
      continue;
    }

    if (ownerVariantId && ownerVariantId !== Number(variantId)) {
      break;
    }

    result.push(media);
  }

  return result;
}

function sizedImageUrl(src, width) {
  if (!src || !width) return src || '';
  const sep = src.includes('?') ? '&' : '?';
  return `${src}${sep}width=${width}`;
}

// Mirrors the video branch of snippets/product-one-pager-media-slide.liquid:
// highest mp4 first, HLS last. The tile is 400-534px wide, so on a 2x screen it
// needs 800-1068px and the top rendition is already the ceiling - a lower rung
// first reads as a blurry loop.
function buildVideoHTML(media, posterSrc) {
  const all = media.sources || [];
  const ordered = [
    ...all.filter(s => s.format === 'mp4').sort((a, b) => b.height - a.height),
    ...all.filter(s => s.format !== 'mp4')
  ];
  const sources = ordered
    .map(source => `<source src="${source.url}" type="${source.mime_type}">`)
    .join('');

  return `
      <video class="tw-block tw-min-h-[480px] tw-w-full tw-h-full tw-object-cover lg:tw-rounded-x2.5 fu:tw-rounded-x3 lg:tw-min-h-fit" poster="${sizedImageUrl(posterSrc, 800)}" preload="metadata" autoplay loop muted playsinline>
        ${sources}
      </video>`;
}

function buildImageHTML(
  baseSrc,
  escapedAlt,
  { isFirstSlide, width, height } = {}
) {
  const dimensionAttrs =
    width && height ? ` width="${width}" height="${height}"` : '';
  const priorityAttrs = isFirstSlide
    ? 'loading="eager" fetchpriority="high"'
    : 'loading="lazy" fetchpriority="low"';

  return `
      <a href="${baseSrc}" class="product_gallery tw-absolute tw-inset-0 !tw-block lg:tw-cursor-pointer" data-caption="${escapedAlt}" data-fancybox="set"></a>
      <picture>
        <source srcset="${sizedImageUrl(baseSrc, 534)}, ${sizedImageUrl(baseSrc, 1068)} 2x" media="(min-width: 1920px)">
        <source srcset="${sizedImageUrl(baseSrc, 400)}, ${sizedImageUrl(baseSrc, 800)} 2x" media="(min-width: 1440px)">
        <source srcset="${sizedImageUrl(baseSrc, 356)}, ${sizedImageUrl(baseSrc, 712)} 2x" media="(min-width: 1280px)">
        <img class="tw-min-h-[480px] tw-w-full tw-h-full tw-object-cover lg:tw-rounded-x2.5 fu:tw-rounded-x3 lg:tw-min-h-fit" srcset="${sizedImageUrl(baseSrc, 343)}, ${sizedImageUrl(baseSrc, 686)} 2x"${dimensionAttrs} ${priorityAttrs} alt="${escapedAlt}">
      </picture>`;
}

function buildSlideHTML(media, { isFirstSlide, badgeHTML, productTitle } = {}) {
  const preview = media.preview_image || media.image || {};
  const baseSrc = preview.src || media.src || '';
  const escapedAlt = (preview.alt || productTitle || '').replace(
    /"/g,
    '&quot;'
  );

  const mediaHTML =
    media.media_type === 'video'
      ? buildVideoHTML(media, baseSrc)
      : buildImageHTML(baseSrc, escapedAlt, {
          isFirstSlide,
          width: preview.width,
          height: preview.height
        });

  // Wrapper must match the badge wrapper in
  // snippets/product-one-pager-media-slide.liquid.
  const badgeWrapperHTML =
    isFirstSlide && badgeHTML
      ? `<div class="tw-absolute tw-top-4x tw-left-4x tw-z-[2] tw-flex tw-flex-col tw-items-start lg:tw-top-6x lg:tw-left-6x">${badgeHTML}</div>`
      : '';

  return `
    <div class="tw-relative swiper-slide tw-aspect-[5/6] tw-overflow-hidden lg:tw-aspect-[5/7] tw-w-[calc(100%-16px)] tw-pr-4x tw-min-h-[480px] lg:tw-w-[calc(50%-8px)] lg:tw-h-fit lg:tw-min-h-fit lg:tw-pr-0 fu:tw-w-[calc(50%-10px)]">
      ${badgeWrapperHTML}
      ${mediaHTML}
    </div>`;
}

function renderVariantMedia(variantId) {
  const productJson = window.__PRODUCT__;
  if (!productJson) return;

  const container = document.querySelector('.product__media.swiper');
  if (!container) return;
  const wrapper = container.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  container.style.height = container.offsetHeight + 'px';

  if (container.swiper) {
    container.swiper.destroy(true, false);
    delete container.swiper;
  }

  const badgeTemplate = document.getElementById('product-badge-template');
  const badgeHTML = badgeTemplate ? badgeTemplate.innerHTML.trim() : '';

  const slice = getMediaSliceForVariant(productJson, variantId);
  const productTitle = productJson.title;

  wrapper.innerHTML = slice
    .map((media, index) =>
      buildSlideHTML(media, {
        isFirstSlide: index === 0,
        badgeHTML,
        productTitle
      })
    )
    .join('');

  initProductSwiper();

  // Browsers do not reliably honour the autoplay attribute on media parsed into
  // an already-loaded document, so each video is started explicitly here.
  wrapper.querySelectorAll('video').forEach(video => {
    video.muted = true;
    video.playsInline = true;
    const res = video.play();
    if (res?.catch) res.catch(() => {});
  });

  const IMAGE_DECODE_TIMEOUT_MS = 400;

  const imgs = wrapper.querySelectorAll('img');
  const decoded = Promise.all(
    Array.from(imgs).map(img => img.decode().catch(() => {}))
  );
  const fallback = new Promise(resolve => {
    setTimeout(resolve, IMAGE_DECODE_TIMEOUT_MS);
  });

  Promise.race([decoded, fallback]).then(() => {
    container.style.height = '';
  });
}

function attachVariantChangeHandler() {
  document.addEventListener('change', event => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;

    if (target.name === 'id') {
      const variantId = target.value;
      if (!variantId) return;
      renderVariantMedia(variantId);
    }

    if (target.closest('.size_option_input .size_slider')) {
      updateSizeLabel(target);
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initProductSwiper();
  attachVariantChangeHandler();
});

document.addEventListener('DOMContentLoaded', function () {
  const wrap = document.querySelector('.product__one-pager');
  const buyBtns = document.querySelectorAll('.product-form__button');

  buyBtns.forEach(button => {
    if (button.dataset.listenerAttached) return;
    button.dataset.listenerAttached = 'true';

    button.addEventListener('click', e => {
      if (!e.isTrusted) return;

      const from = button.classList.contains('set_sticky-btn')
        ? 'product_quick_add'
        : 'product_main';

      const prodPriceElement = wrap.querySelector(
        '.no-js-hidden .price-item--sale'
      );
      const priceTarget =
        prodPriceElement && prodPriceElement.querySelector('.money')
          ? prodPriceElement.querySelector('.money')
          : prodPriceElement;

      const formInput = wrap.querySelector('.product-form input[name="id"]');

      addToCartEvent(
        1,
        from,
        formInput.value,
        priceTarget ? priceTarget.textContent.trim() : '',
        formInput.dataset.handle,
        formInput.dataset.url,
        '',
        readPdpEventExtras()
      );
      if (!document.body.classList.contains('hide-header')) {
        setTimeout(() => {
          window.location.href = `${window.Shopify?.routes?.root ?? '/'}checkout`;
        }, 900);
      }
    });
  });
});
